class SplashScreen extends HTMLElement {
  static LOGO_EMPTY = '';
  static LOGO_SKELETON = 'skeleton';

  static ATTR_LOGO_NAME = 'logo';

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return [SplashScreen.ATTR_LOGO_NAME];
  }

  connectedCallback() {
    if (!this.shadowRoot) {
      this.render();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === SplashScreen.ATTR_LOGO_NAME && newValue !== oldValue) {
      this.render(newValue);
    }
  }

  renderStyles() {
    return `
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes skeletonLoaderAnimation {
  100% {
    transform: translateX(100%);
  }
}

:host {
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #F8F9FA;
}

.logo {
  margin-bottom: 30px;
  margin-left: calc(100vw - 100%);
  max-width: 90%;
}

.spinner {
  animation: rotate 2s linear infinite;
  margin-left: calc(100vw - 100%);
  width: 50px;
  height: 50px;
}

.spinner .path {
  stroke: #0D6EFD;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

.skeleton {
  aspect-ratio: 429 / 70;
  background-color: #e4e6ef;
  border-radius: 2px;
  display: block;
  margin-bottom: 20px;
  max-width: 90%;
  overflow: hidden;
  position: relative;
  width: 429px;
}

.skeleton::after {
  animation: skeletonLoaderAnimation .8s infinite;
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.4) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  bottom: 0;
  content: '';
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(-100%);
}

    `;
  }

  render(logo) {
    let logoHtml = '';
    switch (logo) {
      case SplashScreen.LOGO_EMPTY:
        logoHtml = '';
        break;
      case SplashScreen.LOGO_SKELETON:
        logoHtml = '<div class="skeleton"></div>';
        break;
      default:
        logoHtml = `<img src="${logo}" alt="Logo" class="logo"/>`
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${this.renderStyles()}
      </style>

      <!-- @todo: Uncomment when double rendering will be fixed -->
      <!-- ${logoHtml} -->
      <svg class="spinner" viewBox="0 0 50 50">
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        ></circle>
      </svg>
    `;
  }
}

customElements.define('splash-screen', SplashScreen);
